module.exports = __webpack_public_path__ + "img/header-phone-1.12fd0b67.png";